export default class ModelAnalysisResult {
  constructor(data) {
    this.Id = data.Id;
    this.Name = data.Name;
    this.FileName = data.FileName;
    this.Public = data.Public || false;
    this.Formulas = data.Formulas || [];
    this.DataSources = data.DataSources || [];
    this.Error = data.Error || null;
  }
}
